module.exports = __webpack_public_path__ + "static/media/team_logo.486a0dbb.svg";